"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright (C) 2017-2019 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
const three_1 = require("three");
const tmpColor = new three_1.Color();
const tmpHSL = { h: 0, s: 0, l: 0 };
/**
 * Enumeration of supported string encoded numerals.
 */
var StringEncodedNumeralType;
(function (StringEncodedNumeralType) {
    StringEncodedNumeralType[StringEncodedNumeralType["Meters"] = 0] = "Meters";
    StringEncodedNumeralType[StringEncodedNumeralType["Pixels"] = 1] = "Pixels";
    StringEncodedNumeralType[StringEncodedNumeralType["Hex"] = 2] = "Hex";
    StringEncodedNumeralType[StringEncodedNumeralType["RGB"] = 3] = "RGB";
    StringEncodedNumeralType[StringEncodedNumeralType["HSL"] = 4] = "HSL";
})(StringEncodedNumeralType = exports.StringEncodedNumeralType || (exports.StringEncodedNumeralType = {}));
exports.StringEncodedMeters = {
    type: StringEncodedNumeralType.Meters,
    size: 1,
    regExp: /((?=\.\d|\d)(?:\d+)?(?:\.?\d*))m/,
    decoder: (encodedValue) => {
        return [Number(exports.StringEncodedMeters.regExp.exec(encodedValue)[1])];
    }
};
exports.StringEncodedPixels = {
    type: StringEncodedNumeralType.Pixels,
    size: 1,
    mask: 1.0,
    regExp: /((?=\.\d|\d)(?:\d+)?(?:\.?\d*))px/,
    decoder: (encodedValue) => {
        return [Number(exports.StringEncodedPixels.regExp.exec(encodedValue)[1])];
    }
};
exports.StringEncodedHex = {
    type: StringEncodedNumeralType.Hex,
    size: 3,
    regExp: /#([0-9A-Fa-f]{1,2})([0-9A-Fa-f]{1,2})([0-9A-Fa-f]{1,2})/,
    decoder: (encodedValue) => {
        tmpColor.set(encodedValue).getHSL(tmpHSL);
        return [tmpHSL.h, tmpHSL.s, tmpHSL.l];
    }
};
exports.StringEncodedRGB = {
    type: StringEncodedNumeralType.RGB,
    size: 3,
    // tslint:disable-next-line:max-line-length
    regExp: /rgb\((?:([0-9]{1,2}|1[0-9]{1,2}|2[0-4][0-9]|25[0-5]), ?)(?:([0-9]{1,2}|1[0-9]{1,2}|2[0-4][0-9]|25[0-5]), ?)(?:([0-9]{1,2}|1[0-9]{1,2}|2[0-4][0-9]|25[0-5]))\)/,
    decoder: (encodedValue) => {
        const channels = exports.StringEncodedRGB.regExp.exec(encodedValue);
        tmpColor
            .setRGB(parseInt(channels[1], 10) / 255, parseInt(channels[2], 10) / 255, parseInt(channels[3], 10) / 255)
            .getHSL(tmpHSL);
        return [tmpHSL.h, tmpHSL.s, tmpHSL.l];
    }
};
exports.StringEncodedHSL = {
    type: StringEncodedNumeralType.HSL,
    size: 3,
    // tslint:disable-next-line:max-line-length
    regExp: /hsl\(((?:[0-9]|[1-9][0-9]|1[0-9]{1,2}|2[0-9]{1,2}|3[0-5][0-9]|360)), ?(?:([0-9]|[1-9][0-9]|100)%), ?(?:([0-9]|[1-9][0-9]|100)%)\)/,
    decoder: (encodedValue) => {
        const channels = exports.StringEncodedHSL.regExp.exec(encodedValue);
        return [
            parseInt(channels[1], 10) / 360,
            parseInt(channels[2], 10) / 100,
            parseInt(channels[3], 10) / 100
        ];
    }
};
/**
 * Array of supported [[StringEncodedNumeralFormat]]s (inteded to be indexed with
 * [[StringEncodedNumeralType]] enum).
 */
exports.StringEncodedNumeralFormats = [
    exports.StringEncodedMeters,
    exports.StringEncodedPixels,
    exports.StringEncodedHex,
    exports.StringEncodedRGB,
    exports.StringEncodedHSL
];
